import { useState } from "react";
import { useLayerWeightFormat } from "./useLayerWeightFormat";

export const useLayerWeightInput = ({
  weight,
  massScaleFactor,
  onWeightChange,
}: {
  weight: number;
  massScaleFactor: number;
  onWeightChange: (weight: number) => void;
}) => {
  const weightFormat = useLayerWeightFormat(massScaleFactor);
  const { format, parse } = weightFormat;
  const formattedDisplayWeight = format(weight * massScaleFactor);
  const [seed, setSeed] = useState({ weight, formattedDisplayWeight });
  const [draftWeight, setDraftWeight] = useState(formattedDisplayWeight);

  if (
    seed.weight !== weight ||
    seed.formattedDisplayWeight !== formattedDisplayWeight
  ) {
    setSeed({ weight, formattedDisplayWeight });
    setDraftWeight(formattedDisplayWeight);
  }

  const resetWeight = () => {
    setDraftWeight(formattedDisplayWeight);
  };
  const commitWeight = () => {
    if (draftWeight === formattedDisplayWeight) return;
    const parsedWeight = parse(draftWeight);
    if (parsedWeight.valid && parsedWeight.value > 0) {
      setDraftWeight(format(parsedWeight.value));
      const committedWeight = parsedWeight.value / massScaleFactor;
      if (committedWeight !== weight) onWeightChange(committedWeight);
    } else {
      resetWeight();
    }
  };

  return {
    ...weightFormat,
    draftWeight,
    setDraftWeight,
    commitWeight,
    resetWeight,
  };
};
